import { IFramePlayerAbstractClass } from 'iframe/ts/player/abstract/IFramePlayerAbstractClass';
import { CastNamespace } from 'iframe/ts/player/controller/namespace/CastNamespace';
import { CPNamespace } from 'iframe/ts/player/controller/namespace/CPNamespace';
import { PinGateNamespace } from 'iframe/ts/player/controller/namespace/PinGateNamespace';
import { SkinNamespace } from 'iframe/ts/player/controller/namespace/SkinNamespace';
import { TagNamespace } from 'iframe/ts/player/controller/namespace/TagNamespace';
import { paramsUSER } from 'iframe/ts/player/controller/sequence/utilities/TagSequenceUtilities';
import { IFramePlayerEvent } from 'iframe/ts/player/events/IFramePlayerEvent';
import { IFramePlayerErrorCode } from 'iframe/ts/player/model/error/IFramePlayerErrorCode';
import { IFramePlayerErrorFatal } from 'iframe/ts/player/model/error/IFramePlayerErrorFatal';
import { IFramePlayerErrorInfo } from 'iframe/ts/player/model/error/IFramePlayerErrorInfo';
import { IFramePlayerConstants } from 'iframe/ts/player/model/IFramePlayerConstants';
import { EmbedContext } from 'tag/ts/tag/model/enums/EmbedContext';
import { ParamsVO } from 'tag/ts/tag/model/vo/ParamsVO';
export class AbstractTagSequence extends IFramePlayerAbstractClass {
    #tag;
    constructor(iframePlayer, className = 'AbstractTagSequence') {
        super(iframePlayer, className);
    }
    get tag() {
        return this.#tag;
    }
    #instantiateNamespaces = () => {
        return new Promise((resolve, reject) => {
            resolve({
                msg: 'Tag namespaces instantiated!',
                success: true,
                tagNamespace: new TagNamespace(this.iframePlayer),
                skinNamespace: (this.scripted ? new SkinNamespace(this.iframePlayer) : undefined),
                castNamespace: (this.scripted ? new CastNamespace(this.iframePlayer) : undefined),
                cpNamespace: (this.scripted ? new CPNamespace(this.iframePlayer) : undefined),
                pinGateNamespace: (this.scripted ? new PinGateNamespace(this.iframePlayer) : undefined)
            });
        });
    };
    createTag = (embedContext = EmbedContext.IFRAME_MVP) => {
        return new Promise((resolve, reject) => {
            this.#instantiateNamespaces().then((data) => {
                const paramsVO = new ParamsVO();
                paramsVO.TAG.embedContext = embedContext;
                paramsVO.TAG.container = IFramePlayerConstants.getInstance().smartTagContainer;
                paramsVO.TAG.callback = data.tagNamespace.tagCallback;
                paramsVO.TAG.namespace = {
                    TAG: data.tagNamespace || {},
                    CAST: data.castNamespace || {},
                    SKIN: data.skinNamespace || {},
                    PINGate: data.pinGateNamespace || {},
                    CP: data.cpNamespace || {}
                };
                switch (embedContext) {
                    case EmbedContext.IFRAME_SCRIPTED:
                        paramsVO.USER = paramsUSER({ user: paramsVO.USER, utagData: window?.utag_data, scripted: true });
                        paramsVO.TAG.uuid = this?.iframePlayer?.runtimeVO?.uuid;
                        break;
                    case EmbedContext.IFRAME_MVP:
                        paramsVO.USER = paramsUSER({ user: paramsVO.USER, utagData: window?.utag_data, scripted: false });
                        break;
                }
                window?.SmartTag.create(paramsVO).then((data) => {
                    this?.logger?.log('createTagInstance:', data);
                    this.#tag = data.tag;
                    this.utils.Delay.delay().then(() => {
                        this.dispatchIFramePlayerEvent({
                            type: IFramePlayerEvent.ON_TAG_CREATE_SUCCESS,
                            target: this,
                            targetName: this.name
                        });
                        resolve(data);
                    });
                }).catch((error) => {
                    this?.logger?.warn('createTagInstance: ERROR:', error);
                    this.dispatchIFramePlayerEvent({
                        type: IFramePlayerEvent.ON_ERROR,
                        error: {
                            code: IFramePlayerErrorCode.P1002,
                            info: IFramePlayerErrorInfo[IFramePlayerErrorCode.P1002],
                            fatal: IFramePlayerErrorFatal[IFramePlayerErrorCode.P1002],
                            original: error
                        },
                        target: this,
                        targetName: this.name
                    });
                });
            });
        });
    };
}
